module.exports = __webpack_public_path__ + "img/tech-full.d39bf877.png";